import React, { FC } from 'react'
import styled from 'styled-components'

import { ButtonStyled, Text, Title } from './CssStyled'
import InfinityObserver from 'components/Observer/InfinityObserver'
import { ISection } from '../interfaces'
import Link from '@ads/front-core/atoms/Link'
import { breakpoints } from '@ads/front-core/constants/breakpoints'
import { lng } from '@ads/front-core/locales'

const JoinUs: FC<ISection> = ({ setActiveMenu }) => (
  <InfinityObserver callback={() => setActiveMenu('JoinUs')}>
    <Container>
      <Content>
        <Title bold color="inverted100">
          SalesBooster
        </Title>

        <Text color="inverted100">{lng('landing:salesBoosterContent')}</Text>

        <ButtonGetStarted to="/1login/">
          {lng('landing:checkNow')}
        </ButtonGetStarted>
      </Content>

      <ImgWrapper></ImgWrapper>
    </Container>
  </InfinityObserver>
)

const Container = styled.div`
  position: relative;
  display: flex;
  margin: 0 -60px 0 -60px;
  padding-left: 60px;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    right: 50%;
    width: 100vw;
    margin-left: -50vw;
    margin-right: -50vw;
    bottom: 0;
    top: 0;
    background-color: #262a44;
    z-index: -1;
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    flex-direction: column;
    margin: 0;
    padding: 0;
  }
`

const Content = styled.div`
  position: relative;
  display: flex;
  gap: 24px;
  flex-direction: column;
  padding: 60px 0;

  @media (max-width: ${breakpoints.MOBILE}) {
    padding: 24px 0;
  }
`

const ImgWrapper = styled.div`
  position: relative;
  width: 100%;
  background: url('/img/landing/img_2.png');
  background-repeat: no-repeat;
  background-size: cover;

  &:after {
    content: '';
    position: absolute;
    left: -1px;
    top: 0;
    bottom: 0;
    right: 50%;
    background: linear-gradient(
      90deg,
      rgb(38, 42, 68) 0%,
      rgba(38, 42, 68, 0) 90.29%
    );
  }

  @media (max-width: ${breakpoints.MOBILE}) {
    height: 415px;
    background-position: top;
    margin: 0px -16px;
    width: auto;

    &:after {
      content: '';
      position: absolute;
      right: 0;
      background: linear-gradient(
        -180deg,
        rgb(38, 42, 68) 0%,
        rgba(38, 42, 68, 0) 90.29%
      );
    }
  }
`

const ButtonGetStarted = styled(Link)`
  ${ButtonStyled}

  @media (max-width: ${breakpoints.MOBILE}) {
    align-self: center;
  }
`

export default JoinUs
